import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

type videoList = { [s: string]: string };
type Props = {
    videoLink: keyof videoList
}
type Emits = {
    (e: 'close'): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'popup-video',
  props: {
    videoLink: null
  },
  emits: ["close"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    videoLink: keyof videoList
}





const videos: videoList = {
    'intro': 'https://firebasestorage.googleapis.com/v0/b/leanmeet-optme.appspot.com/o/videos%2FBeta%20product%20vid%20%231-opt%20product%20intro.MP4?alt=media&token=dd0cbdbd-4865-402d-8e27-5ed91b0ab241',
    'calendar' : 'https://firebasestorage.googleapis.com/v0/b/leanmeet-optme.appspot.com/o/videos%2FBeta%20product%20vid%20%232-calendar%20integration.MP4?alt=media&token=53208169-92b8-4715-86cc-be010d898e3d',
    'meetingType': 'https://firebasestorage.googleapis.com/v0/b/leanmeet-optme.appspot.com/o/videos%2FBeta%20product%20vid%20%233-%20meeting%20type.MP4?alt=media&token=1e288eb9-7875-44a9-8dc1-a9ff51427db9',
    'transactionFee': 'https://firebasestorage.googleapis.com/v0/b/leanmeet-optme.appspot.com/o/videos%2FBeta%20product%20vid%20%234-transaction%20fee.MP4?alt=media&token=c311f581-a030-4949-9b6b-3897a85761d3',
    'whatNow': 'https://firebasestorage.googleapis.com/v0/b/leanmeet-optme.appspot.com/o/videos%2FBeta%20product%20vid%20%235-so%20now%20what.MP4?alt=media&token=fd9384cc-2ae7-449d-9132-9014761fca00'
}


const __returned__ = { props, emit, videos, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})